var map = {
	"./address_image.svg": 166,
	"./animated_ashutosh.png": 167,
	"./animated_logo.svg": 168,
	"./app_images/emsigner/Choose signature type.webp": 82,
	"./app_images/emsigner/Collaborate with.webp": 83,
	"./app_images/emsigner/Envelope signed &.webp": 84,
	"./app_images/emsigner/Simplify Your.webp": 46,
	"./app_images/emsigner/Stay in Control.webp": 85,
	"./app_images/emsigner/• Proposa.webp": 86,
	"./app_images/shanghai/Easy Food Ordering.webp": 47,
	"./app_images/shanghai/Exclusive Deals & Offers.webp": 87,
	"./app_images/shanghai/Explore Top Eateries.webp": 88,
	"./app_images/shanghai/Personalized.webp": 89,
	"./app_images/shanghai/Real-Time Tracking.webp": 90,
	"./app_images/t2p/Find Practice.webp": 93,
	"./app_images/t2p/Free.webp": 95,
	"./app_images/t2p/How to Use.webp": 94,
	"./app_images/t2p/Live Chat.webp": 92,
	"./app_images/t2p/Matching.webp": 91,
	"./app_images/t2p/Spoken English.webp": 48,
	"./blogs_image.svg": 169,
	"./bunni_image/Empowering Students.png": 41,
	"./bunni_image/Our Gallery.png": 73,
	"./cloud_infrastructure.svg": 170,
	"./codeInLogo.png": 171,
	"./code_image.png": 71,
	"./commit_image.png": 72,
	"./contactMail.png": 23,
	"./coursera_logo.png": 172,
	"./data_science.svg": 173,
	"./deeplearning_ai_logo.png": 174,
	"./delhivery_logo.png": 175,
	"./developerActivity.svg": 101,
	"./dsc_logo.png": 176,
	"./education.svg": 177,
	"./evtaar/GROW YOUR BUSINESS SEAMLESSI.png": 45,
	"./evtaar/Pasted Graphic 10.png": 79,
	"./evtaar/Pasted Graphic 11.png": 80,
	"./evtaar/Pasted Graphic 12.png": 81,
	"./evtaar_logo.jpeg": 100,
	"./experience.svg": 178,
	"./feelingProud.svg": 179,
	"./formula_figma_image.png": 68,
	"./formula_image.png": 40,
	"./formula_mobile.png": 69,
	"./formula_tab_ui.png": 70,
	"./frdel_studios_logo.jpeg": 180,
	"./freecopy_logo.png": 181,
	"./frovo_image/Frovo for Businesses.png": 77,
	"./frovo_image/How Frovo Works.png": 76,
	"./frovo_image/Join the Future of Smart Retail - bulld with Frovo.png": 78,
	"./frovo_image/Life Can't Wait.png": 44,
	"./fullstack.svg": 182,
	"./gcp_logo.png": 183,
	"./github_logo.png": 184,
	"./googleAssistant.jpg": 185,
	"./googleAssistant.svg": 186,
	"./google_logo.png": 187,
	"./ibm_logo.png": 188,
	"./iiitk_logo.png": 189,
	"./intel_logo.jpg": 190,
	"./iu_logo.png": 191,
	"./jsFramework.svg": 192,
	"./legato_logo.png": 193,
	"./manOnTable.svg": 194,
	"./microsoft_logo.png": 195,
	"./mozilla_logo.png": 196,
	"./muffito_logo.png": 197,
	"./my_image.png": 104,
	"./nextuLogo.jpg": 198,
	"./north_bengal.jpeg": 199,
	"./nptel_logo.png": 200,
	"./panskura_college.jpeg": 201,
	"./portfolio.gif": 202,
	"./programmer.svg": 203,
	"./projects_image.svg": 204,
	"./pwa.png": 205,
	"./saayaHealthLogo.png": 206,
	"./social_images/github.png": 97,
	"./social_images/linked_in.png": 98,
	"./social_images/twitter.png": 99,
	"./stanford_logo.png": 207,
	"./talk2partners/App Launch Otter - spoken english.png": 75,
	"./talk2partners/Talk2Partners.png": 43,
	"./talk2partners_logo.jpeg": 208,
	"./talksCardBack.svg": 209,
	"./talksCardBackAlt.svg": 210,
	"./tiktok_logo.png": 211,
	"./ui_ux_design.svg": 212,
	"./young_guru/SPEAKING.png": 42,
	"./young_guru/Transform Your.png": 74
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 103;